/* eslint-disable camelcase */
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { debounce } from "@utils/lodash";
import utils from "@utils";
import { Loader } from "../../../../components";
import SelectBox from "./SelectBox";
import ClientIcon from "../../../../images/reportIcons/client-report.svg?svgr";
import InvoiceIcon from "../../../../images/reportIcons/invoice-report.svg?svgr";
import LocationIcon from "../../../../images/reportIcons/location-report.svg?svgr";
import OfficerIcon from "../../../../images/reportIcons/officer-report.svg?svgr";
import ReceiptIcon from "../../../../images/reportIcons/payment-report.svg?svgr";
import TransactionIcon from "../../../../images/reportIcons/transaction-report.svg?svgr";
import AgencyIcon from "../../../../images/reportIcons/agency-report.svg?svgr";
import DefaultIcon from "../../../../images/reportIcons/custom-report.svg?svgr";
import RollKallIcon from "../../../../images/reportIcons/rollkall-report.svg?svgr";

const report_icons = {
	client: ClientIcon,
	invoice: InvoiceIcon,
	location: LocationIcon,
	officer: OfficerIcon,
	receipt: ReceiptIcon,
	transaction: TransactionIcon,
	agency: AgencyIcon,
	default: DefaultIcon,
    rollkall: RollKallIcon
};

class ReportGrid extends Component {
	constructor(props) {
		super(props);

		const { user } = this.props;

		this.state = {
			reportsLoaded: false,
            superAdminReports: false,
            isLoading: false,
		};
		if (!user.isSuperAdmin()) {
			this.loadReports(user, user.Organization.Id);
		}
		this.loadJurisdictions = debounce(utils.loadJurisdictions, 500);
	}

	loadReports = async (user, agencyId) => {
        this.setState({ reportsLoaded: false })
        this.setState({ superAdminReports: agencyId === 9152})
		const ReportTypeArray = await user.getReports(agencyId);
		let reportTypes = [];

		if (
			ReportTypeArray.length !== 0 &&
			Object.prototype.hasOwnProperty.call(ReportTypeArray[0], "Source")
		) {
			reportTypes = ReportTypeArray.map(reportType => ({
				value: reportType.Key,
				label: reportType.Name,
				source: reportType.Source,
				id: reportType.Id,
				category: reportType.Category?.toLowerCase(),
				description: reportType.Description,
                filter: reportType.CustomFilter
			}))
            .filter(r => r.source.toLowerCase().includes("domo"))
            .sort((a, b) => {
                const aUpgrade = a.label.includes("Upgrade");
                const bUpgrade = b.label.includes("Upgrade");

                if ( bUpgrade && !aUpgrade ) return -1;
                if ( aUpgrade && !bUpgrade ) return 1;

                return a.label.localeCompare(b.label)
            })
		}

		this.reportTypes = reportTypes;
        this.setState({ reportsLoaded: true });
	};

	createSelectBox = parameters => {
		const { updateFilters, setReportState, resetReportParams } = this.props;

		return {
			property: parameters.property,
			type: parameters.type ? parameters.type : "select",
			name: parameters.name,
			value: parameters.value,
			data: parameters.data,
			loading: parameters.loading,
			onChange: (e, property) => {
				const value = e ? e.value : "";
				updateFilters(property, value);
				setReportState({ renderReport: false });
                this.setState({superAdminReports: false})
				resetReportParams();

				if (parameters.callback) parameters.callback(value);
			},
		};
	};

	buildAgencyFilter = () => {
		const { lang } = global;
		const {
			filters: { agencyId },
			agencies,
			loaders,
			setReportState,
			user,
		} = this.props;

		return this.createSelectBox({
			property: "agencyId",
			name: lang.t("Agency"),
			value: agencyId,
			data: agencies,
			loading: loaders.agencies,
			callback: value => {
				// Reset related filters
				setReportState(prevState => ({
					filters: {
						...prevState.filters,
					},
				}));
				if (value && user.isSuperAdmin()) {
					this.loadReports(user, value);
				}
			},
		});
	};

	build_agency_selector = () => {
		const { user } = this.props;
		const filters = [];

		if (user.isSuperAdmin()) filters.push(this.buildAgencyFilter());

		return filters;
	};

	build_super_admin_agency_selectors = () => this.build_agency_selector();

	onReportChange = event => {
		const {
			setReports,
			setReportState,
			resetFilters,
			resetReportParams,
			generateReportBtnCallback,
		} = this.props;

		resetFilters(() =>
			setReportState({
				reportType: event?.label || "",
				reportId: event?.id || "",
				reportSource: event?.source || "rollkall",
				renderReport: false,
			}),
		);
        
        this.setState({isLoading: true})
		setReports({ reports: this.reportTypes });

		resetReportParams();
		// Ensuring state is selected
		setTimeout(() => {
			generateReportBtnCallback();
		}, 100);
        // clear loading
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 1000)
	};

	onOverrideChange = e => {
		const { setReportState } = this.props;

		setReportState({
			filters: { agencyId: e },
		});
	};

    loadSuperAdminReports = () => {
        const { user, updateFilters } = this.props;
        
        // Clear out any text from the Agency Dropdown Selectbox
        updateFilters('agencyId', '');
        const superAdminAccount = 9152
        this.loadReports(user, superAdminAccount);
    }

	render() {
		const { reportsLoaded, superAdminReports, isLoading } = this.state;

		const { user, reportType, showAgencyReportOverride } = this.props;

		const agencySelectBox = user.isSuperAdmin()
			? this.build_super_admin_agency_selectors()
			: [];
		const reports = reportsLoaded ? this.reportTypes : [];

		return (
			<Fragment>
				<div className="flex flex-align-items-center flex-justify-content-space-between agency-select-flex">
					<For
						each="item"
						index="index"
						of={agencySelectBox}
					>
						<div
							key={`reports_filter_${index}`}
							className="form-group"
						>
							<SelectBox
								filter={item}
								handleOnFilter={item.onChange}
							/>
						</div>
					</For>
                    <If condition={user.isSuperAdmin()}>
                        <button
							type="button"
                            className={`btn load-super-admin-button ${superAdminReports ? "btn-gray": "btn-primary"}`}
                            onClick={() => {
                                this.loadSuperAdminReports();
                            }}
                        > Super Admin Reports
                        </button>
                    </If>
					<If condition={showAgencyReportOverride}>
						<span className="agency-override">
							<label htmlFor="AgencyOverride">
								Agency Override
								<input
									id="AgencyOverride"
									type="text"
									className="agency-override-text"
									onKeyDown={e => {
										this.onOverrideChange(e.target.value);
									}}
									onChange={e => {
										this.onOverrideChange(e.target.value);
									}}
								/>
							</label>
						</span>
					</If>
				</div>
				<div className="flex flex-direction report-grid">
                    <For
                        each="reportType"
                        index="index"
                        of={reports}
                    >
                        <div className="report-container">
                            <If condition={reportType?.filter && reportType.filter !== '[$*$]'  /* SuperAdmin Specific */ } >
                                <span class="custom-ribbon">Custom</span>
                            </If>
                            <div
                                className="base-report-container"
                                value={reportType}
                                onClick={() => {
                                    this.onReportChange(reportType);
                                }}
                                onKeyDown={() => {
                                    this.onReportChange(reportType);
                                }}
                                role="presentation"
                            >
                                <div>
                                    <div>
                                        {React.createElement(
                                            report_icons[reportType.category] ||
                                                report_icons.default,
                                            {
                                                className: "report-picker-icon",
                                            },
                                        )}
                                    </div>
                                    <div className="view-report-button">
                                        <If condition={!reportType?.filter || reportType.filter === '[$*$]' /* SuperAdmin Specific */} >View Report</If>
                                    </div>
                                </div>
                                <div className="base-report-title">{reportType.label}</div>
                                <div className="base-report-description">
                                    {reportType.description}
                                </div>
                            </div>
                        </div>
                    </For>
				</div>
                <Loader active={isLoading} />
			</Fragment>
		);
	}
}

ReportGrid.propTypes = {
	agencies: PropTypes.array,
	filters: PropTypes.object,
	generateReportBtnCallback: PropTypes.func.isRequired,
	loaders: PropTypes.object.isRequired,
	setReports: PropTypes.object.isRequired,
	setReportState: PropTypes.func.isRequired,
	reportType: PropTypes.string,
	resetFilters: PropTypes.func.isRequired,
	resetReportParams: PropTypes.func.isRequired,
	updateFilters: PropTypes.func.isRequired,
	user: PropTypes.object,
	showAgencyReportOverride: PropTypes.bool,
};

ReportGrid.defaultProps = {
	agencies: [],
	filters: {},
	reportType: "",
	user: {},
	showAgencyReportOverride: false,
};
export default ReportGrid;
